import Parse from "parse";

import type { Industry } from "./Industry";
import type { Region } from "./Region";
import type { _User } from "./_User";

export interface BenchmarkAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  answers: any;
  company_revenue?: string | undefined;
  company_size?: string | undefined;
  contact_city?: string | undefined;
  contact_company?: string | undefined;
  contact_email?: string | undefined;
  contact_get_in_touch?: boolean | undefined;
  contact_name?: string | undefined;
  contact_newsletter?: boolean | undefined;
  contact_phone?: string | undefined;
  contact_position?: string | undefined;
  contact_post_code?: string | undefined;
  contact_street?: string | undefined;
  industry?: Industry | undefined;
  industry_other?: string | undefined;
  isFinished: boolean;
  region?: Region | undefined;
  region_other?: string | undefined;
  secret?: string | undefined;
  user?: _User | undefined;
}

export class Benchmark extends Parse.Object<BenchmarkAttributes> {
  static className: string = "Antiscam_Benchmark";

  constructor(data?: Partial<BenchmarkAttributes>) {
    super("Antiscam_Benchmark", data as BenchmarkAttributes);
  }

  get answers(): any {
    return super.get("answers");
  }
  set answers(value: any) {
    super.set("answers", value);
  }

  get company_revenue(): string | undefined {
    return super.get("company_revenue");
  }
  set company_revenue(value: string | undefined) {
    super.set("company_revenue", value);
  }

  get company_size(): string | undefined {
    return super.get("company_size");
  }
  set company_size(value: string | undefined) {
    super.set("company_size", value);
  }

  get contact_city(): string | undefined {
    return super.get("contact_city");
  }
  set contact_city(value: string | undefined) {
    super.set("contact_city", value);
  }

  get contact_company(): string | undefined {
    return super.get("contact_company");
  }
  set contact_company(value: string | undefined) {
    super.set("contact_company", value);
  }

  get contact_email(): string | undefined {
    return super.get("contact_email");
  }
  set contact_email(value: string | undefined) {
    super.set("contact_email", value);
  }

  get contact_get_in_touch(): boolean | undefined {
    return super.get("contact_get_in_touch");
  }
  set contact_get_in_touch(value: boolean | undefined) {
    super.set("contact_get_in_touch", value);
  }

  get contact_name(): string | undefined {
    return super.get("contact_name");
  }
  set contact_name(value: string | undefined) {
    super.set("contact_name", value);
  }

  get contact_newsletter(): boolean | undefined {
    return super.get("contact_newsletter");
  }
  set contact_newsletter(value: boolean | undefined) {
    super.set("contact_newsletter", value);
  }

  get contact_phone(): string | undefined {
    return super.get("contact_phone");
  }
  set contact_phone(value: string | undefined) {
    super.set("contact_phone", value);
  }

  get contact_position(): string | undefined {
    return super.get("contact_position");
  }
  set contact_position(value: string | undefined) {
    super.set("contact_position", value);
  }

  get contact_post_code(): string | undefined {
    return super.get("contact_post_code");
  }
  set contact_post_code(value: string | undefined) {
    super.set("contact_post_code", value);
  }

  get contact_street(): string | undefined {
    return super.get("contact_street");
  }
  set contact_street(value: string | undefined) {
    super.set("contact_street", value);
  }

  get industry(): Industry | undefined {
    return super.get("industry");
  }
  set industry(value: Industry | undefined) {
    super.set("industry", value);
  }

  get industry_other(): string | undefined {
    return super.get("industry_other");
  }
  set industry_other(value: string | undefined) {
    super.set("industry_other", value);
  }

  get isFinished(): boolean {
    return super.get("isFinished");
  }
  set isFinished(value: boolean) {
    super.set("isFinished", value);
  }

  get region(): Region | undefined {
    return super.get("region");
  }
  set region(value: Region | undefined) {
    super.set("region", value);
  }

  get region_other(): string | undefined {
    return super.get("region_other");
  }
  set region_other(value: string | undefined) {
    super.set("region_other", value);
  }

  get secret(): string | undefined {
    return super.get("secret");
  }
  set secret(value: string | undefined) {
    super.set("secret", value);
  }

  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("Antiscam_Benchmark", Benchmark);
